
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/build-layouts-faster-with-grid-v2",
      function () {
        return require("private-next-pages/blog/build-layouts-faster-with-grid-v2.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/build-layouts-faster-with-grid-v2"])
      });
    }
  